import React from 'react';

const RatingsSection = () => {
  // Data for reviews - in a real app, this might come from an API
  const reviews = [
    {
      stars: '★★★★★',
      title: 'Highly recommend',
      text: 'Great tool to help your preflop strategy',
      author: 'June-2-4',
      location: 'United States',
    },
    {
      stars: '★★★★★',
      title: 'Genial',
      text: 'Je recommande, logiciel simple mais efficace pour comprendre le jeux préflop!',
      author: 'ALL-INpapi',
      location: 'France',
    },
    {
      stars: '★★★★★',
      title: 'Very intuitive, easy to remember',
      text: 'Very intuitive, easy to remember. A great tool for improving your poker game.',
      author: 'Tranvangogo',
      location: 'Vietnam',
    },
    {
      stars: '★★★★★',
      title: 'GTO pré flop',
      text: 'O App é bem dinâmico, e o trainer é fácil de interpretação.',
      author: 'Jorge P. Dos Santos',
      location: 'Brazil',
    },
  ];

  return (
    <section className="ratings-section">
      <div className="container">
        <h2>Trusted by Thousands of Players</h2>
        <div className="ratings-container">
          <div className="ratings-score">
            <h3 className="rating-number">4.9</h3>
            <p className="rating-text">out of 5</p>
            <p className="rating-count">935 Ratings</p>
          </div>
          <div className="ratings-bars">
            <div className="rating-bar">
              <span className="star-count">★★★★★</span>
              <div className="bar-container">
                <div className="bar-fill" style={{ width: '90%' }}></div>
              </div>
            </div>
            <div className="rating-bar">
              <span className="star-count">★★★★</span>
              <div className="bar-container">
                <div className="bar-fill" style={{ width: '6%' }}></div>
              </div>
            </div>
            <div className="rating-bar">
              <span className="star-count">★★★</span>
              <div className="bar-container">
                <div className="bar-fill" style={{ width: '2%' }}></div>
              </div>
            </div>
            <div className="rating-bar">
              <span className="star-count">★★</span>
              <div className="bar-container">
                <div className="bar-fill" style={{ width: '1%' }}></div>
              </div>
            </div>
            <div className="rating-bar">
              <span className="star-count">★</span>
              <div className="bar-container">
                <div className="bar-fill" style={{ width: '1%' }}></div>
              </div>
            </div>
          </div>
        </div>

        <div className="reviews-container">
          {reviews.map((review, index) => (
            <div className="review-card" key={index}>
              <div className="review-stars">{review.stars}</div>
              <h4>{review.title}</h4>
              <p className="review-text">{review.text}</p>
              <div className="review-meta">
                <span className="review-author">{review.author}</span>
                <span className="review-location">{review.location}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RatingsSection; 